export default "__VITE_ASSET__CeQSyypi__"